import * as Yup from "yup";

export const StoreSelectorByAddressSchema = Yup.object().shape({
    estado: Yup.string(),
    cidade: Yup.string(),
    bairro: Yup.string(),
})